import React from 'react';
import { MobileDrawAmount } from './MobileDrawAmount';
import { MobileDrawHistory } from './MobileDrawHistory/MobileDrawHistory';
import { formatCurrency } from '@apply/ui';
import { MobileDrawItem } from '../../MobileDrawControl';

interface MobileDrawBudgetItemParameters {
    mobileDrawItem: MobileDrawItem;
    set_mobileBorrowerRequest: (drawItemId: number, borrowerRequest: number) => void;
    hideFullyFunded: boolean;
    drawItemCalculationMetric: string;
    set_drawAmountCalculationMetric: (calculationMetric: string) => void;
}

export const MobileDrawBudgetItem: React.FC<MobileDrawBudgetItemParameters> = ({
    mobileDrawItem,
    set_mobileBorrowerRequest,
    hideFullyFunded,
    drawItemCalculationMetric,
    set_drawAmountCalculationMetric,
}) => {
    return (
        <>
            <div className={`mobileBudgetItem ${hideFullyFunded && mobileDrawItem.availableAmount <= 0 ? 'hidden' : ''}`}>
                <div className='budgetItemContent'>
                    <div className='header'>{mobileDrawItem.description}</div>
                    <div>
                        <MobileDrawAmount
                            mobileDrawItem={mobileDrawItem}
                            set_mobileBorrowerRequest={set_mobileBorrowerRequest}
                            drawAmountCalculationMetric={drawItemCalculationMetric}
                            set_drawAmountCalculationMetric={set_drawAmountCalculationMetric}
                        />
                    </div>
                    <div className='calculations'>
                        <div className='lineItem'>
                            <div className='descriptor'>Available</div>
                            <div className='calcValue'>{formatCurrency(mobileDrawItem.availableAmount, 2)}</div>
                        </div>
                        <div className='lineItem'>
                            <div className='descriptor active'>This Draw</div>
                            <div className='calcValue active'>
                                {formatCurrency(mobileDrawItem.borrowerRequest ? mobileDrawItem.borrowerRequest : 0, 2)}
                            </div>
                        </div>
                        <div className='lineItem total'>
                            <div className='descriptor'>Remaining</div>
                            <div className='calcValue'>
                                {formatCurrency(mobileDrawItem.availableAmount - (mobileDrawItem.borrowerRequest ?? 0), 2)}
                            </div>
                        </div>
                    </div>
                    <MobileDrawHistory mobileDrawItem={mobileDrawItem} />
                </div>
            </div>
        </>
    );
};
